var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wx_login"},[_c('div',{staticClass:"login_wrap"},[_c('img',{attrs:{"alt":"","src":require("../../assets/img/loading.gif")}}),_vm._v("微信授权中…\n  ")])])
}]

export { render, staticRenderFns }